export interface PopulatedParticipant {
  _id?: string;
  user?: { _id?: string; name?: string } | string;
  requestedReviewers?: string[];
}

export type PairsMap = Record<string, string[]>;

export function getParticipantUserId(p: PopulatedParticipant): string {
  return (typeof p.user === 'object' ? p.user?._id : p.user) ?? '';
}

export function getParticipantName(p: PopulatedParticipant): string {
  if (typeof p.user === 'object') return p.user?.name ?? getParticipantUserId(p);
  return p.user ?? '';
}

export type LoadBand = 'idle' | 'balanced' | 'high' | 'overload';

export function loadBand(n: number): LoadBand {
  if (n === 0) return 'idle';
  if (n <= 4) return 'balanced';
  if (n === 5) return 'high';
  return 'overload';
}

// Нагрузка ревьюера = число участников-предметов, которых он ревьюит.
// Считаем только по участникам (столбцы/строки матрицы).
export function computeLoad(pairs: PairsMap, participantIds: string[]): Record<string, number> {
  const idSet = new Set(participantIds);
  const load: Record<string, number> = {};
  for (const id of participantIds) load[id] = 0;
  for (const subject of participantIds) {
    for (const reviewer of pairs[subject] || []) {
      if (idSet.has(reviewer)) load[reviewer] = (load[reviewer] || 0) + 1;
    }
  }
  return load;
}

export interface AssignmentMetrics {
  total: number;
  avg: number;
  overloaded: number;
  unused: number;
}

export function computeMetrics(pairs: PairsMap, participantIds: string[]): AssignmentMetrics {
  const idSet = new Set(participantIds);
  let total = 0;
  for (const subject of participantIds) {
    for (const reviewer of pairs[subject] || []) {
      if (idSet.has(reviewer)) total += 1;
    }
  }
  const load = computeLoad(pairs, participantIds);
  const loads = participantIds.map((id) => load[id] || 0);
  return {
    total,
    avg: participantIds.length > 0 ? total / participantIds.length : 0,
    overloaded: loads.filter((n) => n >= 6).length,
    unused: loads.filter((n) => n === 0).length,
  };
}
